// CircleNode.js

import React, { useState } from "react";
import PropTypes from "prop-types";
import "./circle-node.css";
import { Handle, Position } from "reactflow";

const CircleNode = ({ data, isConnectable, position }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={`circle-node ${isConnectable ? "connectable" : ""} ${
        isHovered ? "hovered" : ""
      }`}
      style={{ backgroundColor: data.backgroundColor }}
    >
      <div>{data.label}</div>
      {/* <div  className="position">X:{data.x} - Y:{data.y} </div> */}

      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
        className="react-flow__handle-target"
      />
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
        className="react-flow__handle-source"
      />
    </div>
  );
};

CircleNode.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string.isRequired,
    backgroundColor: PropTypes.string.isRequired,
  }),
  isConnectable: PropTypes.bool,
  onNodeEnter: PropTypes.func,
  onNodeLeave: PropTypes.func,
};

export default CircleNode;
